/**
 * functions that show you popups, snackbars and warnings
 */
//TODO: think of a better name for this file !!!

import ui from "@/store/modules/ui";

export default function useWarnings() {
  /**
   * checks for unsaved changes. returns true if it is safe to move from page
   */
  const shouldProceed = () => {
    // warn user before moving if unsaved change exists
    if (ui.hasUnsavedChange) {
      const answer = window.confirm("Changes you made might not be saved");
      if (!answer) {
        return false;
      }
    }
    return true;
  };

  return {
    shouldProceed
  };
}
